import React from 'react';
import styled from 'styled-components';
import Calendar from 'rev.sdk.js/Components/Calendar';
import {DT} from 'rev.sdk.js/Components/Calendar/CalendarUtil';

// seasonbakery custom

function DateCell(props) {
  const {
    year,
    month,
    date,
    selectedDts,
    selectedDt,
    classNames: _classNames = [],
    onClick,
    inAdminProductSetting,
    onDelete,
  } = props;
  const curr = DT({year, month, date});

  let classNames = [..._classNames];

  if (inAdminProductSetting) {
    classNames.push('disabled');
    for (const dt of selectedDts) {
      if (
        year === dt.getFullYear() &&
        month === dt.getMonth() &&
        date === dt.getDate()
      ) {
        classNames.push('r-selected');
      }
    }
  } else {
    let included = false;
    for (const dt of selectedDts) {
      if (
        year === dt.getFullYear() &&
        month === dt.getMonth() &&
        date === dt.getDate()
      ) {
        included = true;
        break;
      }
    }
    if (!included) {
      classNames.push('disabled');
    }
    if (
      selectedDt &&
      year === selectedDt.getFullYear() &&
      month === selectedDt.getMonth() &&
      date === selectedDt.getDate()
    ) {
      classNames.push('r-selected');
    }
  }

  return (
    <DateCellWrapper
      className={classNames.join(' ')}
      onClick={(e) => {
        if (classNames.indexOf('disabled') !== -1) return;

        onClick(e);
      }}>
      <label>{date}</label>
      {typeof onDelete === 'function' && classNames.indexOf('r-selected') > -1 && (
        <button
          className="delete"
          onClick={(e) => {
            e.stopPropagation();
            onDelete(curr);
          }}>
          ✖
        </button>
      )}
    </DateCellWrapper>
  );
}

const DateCellWrapper = styled.div`
  position: relative;

  /* here to custom*/
  &.disabled::after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  &.r-cell.r-date.disabled,
  .r-cell.r-date.past {
    color: #ccc;
    & > label {
      cursor: not-allowed;
    }
  }

  &.r-cell.r-date.r-today {
    background-color: var(--background-color);
    border: none;
    & label {
      text-decoration: underline;
    }
  }

  &.r-today::after {
    content: '';
  }

  /* &.r-cell.r-date.r-today.r-selected {
    font-weight: 600;
    background-color: #ffffff;
  } */

  &.r-cell.r-date.r-selected {
    background-color: var(--background-reverse-color);
    color: #fff;
    border: none;
  }

  &.r-cell.r-date:not(.disabled, .past):hover {
    border: none;
    background-color: var(--background-color);
    cursor: pointer;
    & > label {
      color: #000;
      font-weight: 500;
    }
  }

  & > label {
    font-size: 1rem;
  }

  & > button.delete {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #ffffff;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    padding: 0;
    width: 20px;
    height: 20px;
  }
`;

function ProductDetailCalendar(props) {
  const {
    size,
    selectedDts,
    setSelectedDts,
    selectedDt,
    setSelectedDt,
    inAdminProductSetting,
    onClickPrev,
    onClickNext,
    onDelete,
    minDate,
  } = props;

  return (
    <Wrapper size={size}>
      <div className="calendar">
        <Calendar
          defaultValue={new Date(0)}
          onSelect={({year, month, date, dt}) => {
            let next;
            if (inAdminProductSetting) {
              next = [...selectedDts];
              const index = next.findIndex((d) => d.getTime() === dt.getTime());
              if (index !== -1) {
                next.splice(index, 1);
              } else {
                next.push(dt);
              }
              setSelectedDts(next);
            } else {
              next = selectedDt
                ? selectedDt.getTime() === dt.getTime()
                  ? null
                  : dt
                : dt;
              setSelectedDt(next);
            }
          }}
          renderDate={(props) => {
            return (
              <DateCell
                key={props.date}
                {...props}
                selectedDts={selectedDts}
                selectedDt={selectedDt}
                inAdminProductSetting={inAdminProductSetting}
                onDelete={onDelete}
              />
            );
          }}
          //disablePast={true}
          minDate={minDate}
          onClickPrev={onClickPrev}
          onClickNext={onClickNext}
        />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 20px;
  width: ${(props) => props.size}px;

  & > .calendar {
    border: solid 1px var(--input-border-color);

    & > * {
      font: inherit;
    }

    & .r-inner > .r-row.r-head {
      & > .r-cell.r-title {
        font-weight: 300;
      }

      & > .r-cell.r-next::before,
      .r-cell.r-prev::before {
        border-color: var(--text-1-color);
        border-width: 1px;
      }

      & > .r-cell.r-next:hover,
      .r-cell.r-prev:hover {
        background-color: var(--background-color);
        &::before {
          border-color: #000;
          border-width: 2px;
        }
      }
    }
    & .r-inner > .r-row.r-weekdays > .r-cell {
      font-weight: 300;
    }

    & .r-cell {
      border: none;
      background-color: var(--background-color);
    }
  }
`;

export default ProductDetailCalendar;
